import { render } from "./BannerPlano.vue?vue&type=template&id=1c073dfe&scoped=true"
import script from "./BannerPlano.vue?vue&type=script&lang=js"
export * from "./BannerPlano.vue?vue&type=script&lang=js"

import "./BannerPlano.vue?vue&type=style&index=0&id=1c073dfe&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c073dfe"]])

export default __exports__